const rudderAnalyticsReservedKeywords = [
  'anonymous_id',
  'id',
  'sent_at',
  'received_at',
  'timestamp',
  'original_timestamp',
  'event_text',
  'event',
] as const;

export type UserTraits = { id: string } & Partial<{
  firstName: string;
  lastName: string;
  name: string;
  age: number;
  email: string;
  phone: string;
  address: Partial<{ city: string; country: string; postalCode: string; state: string; street: string }>;
  birthday: Date;
  company: { id: string | number } & Partial<{ name: string; industry: string; employee_count: number; plan: string }>;
  createdAt: Date;
  description: string;
  gender: string;
  title: string;
  username: string;
  website: string;
  avatar: string;
}>;

export type UserTrackingBaseProperties = Partial<{
  orgSlug: string;
  orgId: string;
  orgName: string;
  spaceSlug: string;
  spaceName: string;
  spaceId: string;
  fullstoryCurrentSessionUrl: string;
}>;

type RudderAnalyticsReservedKeywords = (typeof rudderAnalyticsReservedKeywords)[number];
type ExcludeReservedKeywords = {
  [key in RudderAnalyticsReservedKeywords]?: never;
};

// https://docs.google.com/spreadsheets/d/1b2CQGf8nyzGMJkcRgrYHZVq2aVSD7DN1VkeyefvtFVE/edit#gid=976767472
export abstract class TrackingEvent<
  Properties extends object & ExcludeReservedKeywords = object & ExcludeReservedKeywords,
  Traits extends Record<string, unknown> | null = Record<string, unknown>,
> {
  constructor(public properties: Properties = {} as Properties, public traits = null as Traits) {}

  abstract name: string;
}
